<script setup lang="ts">
import { computed } from "vue";
import HeaderWrapper from "@/components/layout/headers/desktop/HeaderWrapper.vue";
import MobilePinnedHeader from "@/components/layout/headers/mobile/MobilePinnedHeader.vue";
import { useDevice } from "@/composables/useDevice";

const { isDevice } = useDevice();
const deviceType = computed(() => {
  if (isDevice.value === "desktop" || isDevice.value === "smallDesktop") {
    return "desktop";
  }
  return isDevice.value;
});
</script>

<template>
  <HeaderWrapper v-if="deviceType === 'desktop'" class="desktop-header" />
  <MobilePinnedHeader v-else />
</template>

